import React, { useContext, useState } from 'react';
import { Button, Popconfirm, Tag } from 'antd';
import { ColumnsType } from 'antd/es/table/interface';

import BouncedEmailDetailsContext from '@totem/components/administration/bouncedEmails/details/BouncedEmailDetailsContext';
import { BouncedEmailContact } from '@totem/components/administration/bouncedEmails/types';
import IBTable from '@totem/components/ui_components/antDesignOverrides/IBTable';

const TYPE_LABELS: Record<string, string> = {
  organization: 'Organization',
  building: 'Building',
  controlSystem: 'Control System',
};

const BouncedEmailContactsTable = () => {
  const { details, working, removeContact } = useContext(
    BouncedEmailDetailsContext,
  );
  const [pageSize, setPageSize] = useState<number>(10);

  const columns: ColumnsType<BouncedEmailContact> = [
    {
      title: 'Organization',
      dataIndex: 'organizationName',
      key: 'organizationName',
    },
    {
      title: 'Level',
      dataIndex: 'type',
      key: 'type',
      width: 150,
      render: (type: string) => TYPE_LABELS[type] ?? type,
    },
    {
      title: 'Contact Name',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Labels',
      dataIndex: 'labels',
      key: 'labels',
      render: (labels: string[]) =>
        (labels ?? []).map((label) => <Tag key={label}>{label}</Tag>),
    },
    {
      title: '',
      key: 'actions',
      width: 110,
      render: (_, contact) => (
        <Popconfirm
          title={`Remove this contact from the ${(
            TYPE_LABELS[contact.type] ?? contact.type
          ).toLowerCase()}?`}
          okText="Remove"
          okButtonProps={{ danger: true }}
          onConfirm={() => removeContact(contact)}
        >
          <Button danger size="small" disabled={working}>
            Remove
          </Button>
        </Popconfirm>
      ),
    },
  ];

  return (
    <IBTable<BouncedEmailContact>
      columns={columns}
      dataSource={details?.record?.contacts ?? []}
      rowKey={(contact) => `${contact.type}:${contact.id}`}
      locale={{ emptyText: 'No contacts reference this address.' }}
      pagination={{
        pageSize,
        showSizeChanger: true,
        onShowSizeChange: (_, size) => setPageSize(size),
      }}
    />
  );
};

export default BouncedEmailContactsTable;
